import io from 'socket.io-client'
import { getDashboardPanelUrl } from './panelUrls'

const overrideStyle = {
    display: 'flex',
    margin: '0 auto',
    height: '24px',
    justifyContent: 'center',
    alignItems: 'center'
}

const productionApiUrl = 'https://myshop-api-qfpr.onrender.com'
const localApiUrl = 'http://localhost:5000'

const normalizeUrl = (value) => value ? value.replace(/\/+$/, '') : ''

const isLocalHost = () =>
    typeof window !== 'undefined' &&
    ['localhost', '127.0.0.1'].includes(window.location.hostname)

export const getApiUrl = () => {
    const envApiUrl = normalizeUrl(process.env.REACT_APP_API_URL || '')
    if (envApiUrl) return envApiUrl
    if (isLocalHost()) return localApiUrl
    return productionApiUrl
}

const app_url = getDashboardPanelUrl()
const api_url = getApiUrl()
const mode = api_url === productionApiUrl ? 'pro' : 'dev'

const socket = io(api_url, {
    autoConnect: false,
    withCredentials: true,
    transports: ['websocket', 'polling']
})

export const initSocket = (token) => {
    const nextToken = token || null
    const currentToken = socket.auth?.token || null

    if (socket.connected && currentToken === nextToken) {
        return socket
    }

    if (socket.connected) {
        socket.disconnect()
    }

    socket.auth = nextToken ? { token: nextToken } : {}
    socket.connect()
    return socket
}

export {
    socket,
    app_url,
    api_url,
    mode,
    overrideStyle
}
export const appEnvironment = String(process.env.REACT_APP_APP_ENV || (mode === 'pro' ? 'production' : 'development')).toLowerCase()
